function shopifyFormatCurrency(cents, formatString) {
      const placeholderRegex = /{{\s*(\w+)\s*}}/

      /**
       * Formats a number of cents into a currency string using the provided
       * precision, thousands separator, and decimal separator.
       * @param number - The number of cents to format.
       * @param precision - The number of decimal places to include.
       * @param thousands - The character to use as the thousands separator.
       * @param decimal - The character to use as the decimal separator.
       * @returns The formatted currency string.
       */
      function formatWithDelimiters(
        number,
        precision = 2,
        thousands = ",",
        decimal = "."
      ) {
        if (isNaN(number) || number == null) {
          return "0"
        }

        const numString = (number / 100.0).toFixed(precision)
        const parts = numString.split(".")
        const dollars = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        )
        const cents = parts[1] ? decimal + parts[1] : ""
        return dollars + cents
      }

      return formatString.replace(placeholderRegex, (match, placeholder) => {
        switch (placeholder) {
          case "amount":
            // Ex.	1,134.65
            return formatWithDelimiters(cents, 2)
          case "amount_no_decimals":
            // Ex. 1,135
            return formatWithDelimiters(cents, 0)
          case "amount_with_comma_separator":
            // Ex. 1.134,65
            return formatWithDelimiters(cents, 2, ".", ",")
          case "amount_no_decimals_with_comma_separator":
            // Ex. 1.135
            return formatWithDelimiters(cents, 0, ".", ",")
          case "amount_with_apostrophe_separator":
            // Ex. 1'134.65
            return formatWithDelimiters(cents, 2, "'", ".")
          case "amount_no_decimals_with_space_separator":
            // Ex. 1 135
            return formatWithDelimiters(cents, 0, " ")
          case "amount_with_space_separator":
            // 1 134,65
            return formatWithDelimiters(cents, 2, " ", ",")
          case "amount_with_period_and_space_separator":
            // 1 134.65
            return formatWithDelimiters(cents, 2, " ", ".")
          default:
            return match
        }
      })
    }